export enum EnrollmentConditionSort {
  Name = 1
}